/* eslint-disable import/prefer-default-export */

import omitBy from 'lodash/omitBy';
import { getCart } from './cart-unified';
import constants from '../constants/index';

export function filterFlowProperties(properties) {
  return omitBy(properties, (property, key) => key.startsWith('flow_'));
}

export function invalidateDomCartCache() {
  const cartJsonEl = document.getElementById(constants.CART_JSON_CONTAINER_ID);
  if (cartJsonEl !== null) {
    cartJsonEl.setAttribute(constants.CART_CONSUMED_ATTR_NAME, '');
  }
}

export function getShopifyCart(existingCart) {
  const cart = getCart();

  return new Promise((resolve, reject) => {
    if (existingCart) {
      // invalidate the DOM cart as it must be redundant.
      invalidateDomCartCache();
      resolve(existingCart);
      return;
    }

    cart.shopifyCart.getCart({
      onSuccess: shopifyCart => resolve(shopifyCart),
      onError: error => reject(error),
    });
  });
}



// WEBPACK FOOTER //
// ./static/js/v0/cart_unified/utilities.js